<template>
	<div class="page__top page__top--index page__top--navbar">
		<div class=" container container--navbar">
			<nav class="navbar" role="navigation" aria-label="main navigation">
				<div class="navbar-brand">
					<a class="navbar-item" href="/">
						<img :src="require('@/assets/img/icon-logo.svg')" alt="">
						<img :src="require('@/assets/img/icon-logo-white.svg')" alt="">
					</a>
					<a role="button" class="navbar-burger"  :class="is_active?'is-active':''" @click="is_active=!is_active">
						<span aria-hidden="true"></span>
						<span aria-hidden="true"></span>
						<span aria-hidden="true"></span>
					</a>
				</div>
				<div id="navmenu" class="navbar-menu" :class="is_active?'is-active':''">
					<div class="navbar-start"></div>
					<div class="navbar-end">
						<div class="navbar-item" :class="path=='/'?'current':''">
							<router-link :to="{path:'/'}">首页</router-link>
						</div>
						<div class="navbar-item" :class="path=='/news'?'current':''">
							<router-link :to="{path:'/news'}">新闻动态</router-link>
						</div>
						<div class="navbar-item navbar-item--menu has-dropdown is-hoverable" :class="path=='/brand'?'current':''">
							<router-link :to="{path:'/brand'}">品牌项目</router-link>
							<div class="navbar-dropdown" style="left: -30%">
								<router-link class="navbar-item" :to="{path:'/brand',query:{top:'qingsong'}}">青松计划</router-link>
								<router-link class="navbar-item" :to="{path:'/brand',query:{top:'qimeng'}}">星童计划</router-link>
								<div class="navbar-item navbar-item--menu has-dropdown is-hoverable">
									<router-link class="navbar-item" :to="{path:'/brand',query:{top:'xiangmei'}}">乡美计划</router-link>
									<div class="navbar-dropdown" style="left: 100%;top:0">
										<router-link class="navbar-item" :to="{path:'/brand',query:{top:'xiangmei'}}">乡美计划</router-link>
										<a class="navbar-item navbar-item--large" target="_blank" href="https://course.xuqinsong-art.org.cn/">乡村美术教师网课系统</a>
									</div>
								</div>
								<!-- <router-link class="navbar-item" :to="{path:'/brand',query:{top:'society'}}">社绘计划</router-link> -->
							</div>
						</div>
						<div class="navbar-item navbar-item--menu  has-dropdown is-hoverable" :class="path=='/award'?'current':''">
							<router-link :to="{path:'/award',query:{type:1}}">大奖赛</router-link>
							<div class="navbar-dropdown">
								<router-link class="navbar-item navbar-item--large" :to="{path:'/award/create',query:{type:1}}">许钦松创作奖</router-link>
								<router-link class="navbar-item navbar-item--large" :to="{path:'/award/education',query:{type:2}}">许钦松乡村美术教育奖</router-link>
								<router-link class="navbar-item navbar-item--large" :to="{path:'/award/creativity',query:{type:3}}">许钦松少儿创艺奖</router-link>
							</div>
						</div>
						<div class="navbar-item" :class="path=='/product'?'current':''">
							<router-link :to="{path:'/product'}">获奖作品</router-link>
						</div>
						<div class="navbar-item" :class="path=='/info'?'current':''">
							<router-link :to="{path:'/info'}">信息公开</router-link>
						</div>
						<div class="navbar-item" :class="path=='/about_xqs'?'current':''">
							<router-link :to="{path:'/about_xqs'}">关于许钦松</router-link>
						</div>
						<div class="navbar-item" :class="path=='/about_us'?'current':''">
							<router-link :to="{path:'/about_us'}">关于我们</router-link>
						</div>
					</div>
				</div>
			</nav>
		</div>
	</div>
</template>
<script>
export default {
	name: 'header_html',
	data() {
		return {
			is_active: false,
			path: this.$route.path,
		}
	},
	// 初始事件
	mounted: function() {
		// console.log(this.$route);
	},
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/header_html.vue